import React, { Fragment, useState } from 'react';
import i18next from 'i18next';
import { Icon } from 'antd';
import Button from 'app/components/button';
import Carousel from './carousel';
import Calendar from './calendar';
import IllustrationSVG from 'app/assets/images/home-banner-illustration.svg';
import {
  BannerContainer,
  LeftBannerContainer,
  RightBannerContainer,
  ButtonContainer,
  GridContentContainer,
  ContentContainer,
  TextContentContainer,
  LeftContentContainer,
  RightContentContainer
} from './styles';

export default () => {
  const [ calendarIsOpen, setCalendarIsOpen ] = useState(false);

  function toggleCalendar() {
    setCalendarIsOpen(!calendarIsOpen);
  }

  return (
    <Fragment>
      <Calendar visible={calendarIsOpen} onCancel={toggleCalendar} />

      <BannerContainer>
        <LeftBannerContainer>
          <Carousel />

          <ButtonContainer>
            <Button onClick={toggleCalendar}>
              {i18next.t('home.banner.scheduleMeeting')}
              <Icon type="calendar"/>
            </Button>
          </ButtonContainer>
        </LeftBannerContainer>

        <RightBannerContainer>
          <img src={IllustrationSVG} alt="mobile illustration" />
        </RightBannerContainer>
      </BannerContainer>

      <ContentContainer>
        <GridContentContainer>
          <TextContentContainer>
            <LeftContentContainer>
              <h2>{i18next.t('home.content.left.title')}</h2>
              <p>{i18next.t('home.content.left.text')}</p>

              <Button href="">
                {i18next.t('home.content.knowMore')}
                <Icon type="arrow-right"/>
              </Button>
            </LeftContentContainer>
          </TextContentContainer>

          <TextContentContainer>
            <RightContentContainer>
              <h2>{i18next.t('home.content.right.title')}</h2>
              <p>{i18next.t('home.content.right.text')}</p>

              <Button href="">
                {i18next.t('home.content.knowMore')}
                <Icon type="arrow-right"/>
              </Button>
            </RightContentContainer>
          </TextContentContainer>
        </GridContentContainer>
      </ContentContainer>
    </Fragment>
  );
};
